// extracted by mini-css-extract-plugin
export var downArrow = "_a9-0";
export var label = "_a9-1";
export var treatmentCard = "_a9-3";
export var upArrow = "_a9-2";